import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  get_appts_of_medical_file,
  edit_medical_file,
  edit_medical_status,
} from "../../store/reducers/medicalFileReducer";
import { format } from "date-fns";
import toast from "react-hot-toast";
import { FaCopy } from "react-icons/fa6";

const MedicalFiles = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const userId = userInfo.id;
  const { allMedicalFiles } = useSelector((state) => state.medicalFile);
  const [documents, setDocuments] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [medStatus, setMedStatus] = useState("");
  useEffect(() => {
    dispatch(get_appts_of_medical_file(userId));
  }, [userId, dispatch]);

  const handleFiletClick = (appt) => {
    setSelectedFile(appt);
    setFormData(appt.fileData || {});
    setMedStatus(appt.medStatus);
  };
  const handleCopy = (id) => {
    navigator.clipboard
      .writeText(id)
      .then(() => {
        toast.success("ID copié avec succès - تم نسخ المعرف بنجاح");
      })
      .catch(() => {
        toast.error("Échec de la copie de l'ID");
      });
  };

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleUpload = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) =>
      ["image/png", "image/jpeg", "application/pdf"].includes(file.type)
    );

    if (validFiles.length !== files.length) {
      alert("Only PNG, JPG, or PDF files are allowed.");
      return;
    }

    const newDocs = validFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setDocuments((prevDocs) => [...prevDocs, ...newDocs]);
  };

  // Remove a document
  const handleRemove = (index) => {
    setDocuments((prevDocs) => prevDocs.filter((_, i) => i !== index));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = () => {
    dispatch(
      edit_medical_file({
        medicalFileId: selectedFile._id,
        fileData: formData,
        documents: documents,
      })
    );
    setIsEditing(false);
    setSelectedFile(null);
    setTimeout(() => {
      toast.success("Medical file updated successfully.");
    }, 2000);
  };

  const closeDetails = () => {
    setSelectedFile(null);
    setIsEditing(false);
  };

  const submitMedStatus = (e) => {
    e.preventDefault();
    dispatch(
      edit_medical_status({
        medicalFileId: selectedFile._id,
        medStatus,
      })
    );
  };

  return (
    <div className="bg-white p-4 rounded-md">
      <div className="flex justify-between items-center">
        <h2 className="text-xl sm:text-sm font-semibold text-slate-600">
          Mes dossiers médical - سجلاتي الطبية
        </h2>
      </div>
      <div className="pt-4">
        <div className="relative overflow-x-auto overflow-y-auto max-h-[600px]">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th className="px-3 py-3">ID</th>
                <th className="px-3 py-3">Doctor</th>
                <th className="px-3 py-3">Visites</th>
                <th className="px-3 py-3">Créé le</th>
                <th className="px-3 py-3">Action</th>
              </tr>
            </thead>
            <tbody>
              {allMedicalFiles.map((m, i) => (
                <tr key={i} className="bg-white border-b">
                  <td className=" py-1 font-medium flex justify-center items-center ">
                    <div className="flex justify-center items-center bg-mainBg rounded-md border-2 border-[#00eafb]">
                      <p className=" px-2 ">{m._id}</p>
                      <span
                        onClick={() => handleCopy(m._id)}
                        className="bg-[#00eafb] p-1 w-full h-full rounded-r-md cursor-pointer text-slate-600"
                      >
                        {" "}
                        <FaCopy className=" text-2xl " />{" "}
                      </span>
                    </div>
                  </td>
                  <td className="px-3 py-2 font-medium">{m.doctorData.name}</td>
                  <td className="px-3 py-2 font-medium">
                    {m.appointments.length}
                  </td>
                  <td className="px-3 py-2 font-medium">
                    {format(m.createdAt, "dd-MM-yyyy")}
                  </td>

                  <td className="px-3 py-2">
                    <button
                      onClick={() => handleFiletClick(m)}
                      className="bg-mainBg text-green-800 text-sm font-normal mr-2 px-3.5 py-1 rounded border-r-2 border-[#00eafb]"
                    >
                      Voir
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {selectedFile && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 backdrop-blur-md ">
          <div className="bg-mainBg p-6 rounded-xl shadow-lg w-[80%] lg:w-[95%] lg:h-full h-[95%] overflow-auto">
            <h2 className="text-lg md:text-sm font-semibold mb-6 text-center">
              Données Dossier Medical - بيانات الملف الطبي
            </h2>

            <div className="flex justify-center items-center mr-4 sm:mr-0">
              <p>ID:</p>
              <div className="flex justify-center items-center ml-3 bg-mainBg rounded-md border-2 border-[#00eafb]">
                <p className=" px-2 ">{selectedFile._id}</p>
                <span
                  onClick={() => handleCopy(selectedFile._id)}
                  className="bg-[#00eafb] p-1 w-full h-full rounded-r-md cursor-pointer text-slate-600"
                >
                  {" "}
                  <FaCopy className=" text-2xl " />{" "}
                </span>
              </div>
            </div>
            <div className="flex md:block justify-center items-center md:my-5">
              <div className="mr-3 ">
                <p>Statut actuel: </p>
              </div>
              <form onSubmit={submitMedStatus}>
                <div className="flex gap-4 py-3">
                  <select
                    value={medStatus}
                    onChange={(e) => setMedStatus(e.target.value)}
                    className="px-4 py-0 focus:border-indigo-500 outline-none border border-slate-700 rounded-md"
                    name=""
                    required
                    id=""
                  >
                    <option value="">--select status--</option>
                    <option value="hidden">Caché - مخفي</option>
                    <option value="show">Affiché - مرئي</option>
                    <option value="archive">Archivé - أرشيف</option>
                  </select>
                  <button className="main-btn2 ">Changer</button>
                </div>
              </form>
            </div>

            <div className="flex lg:block overflow-y-auto ">
              <div className="flex flex-col w-full px-4 sm:px-0">
                <div className="bg-slate-50 p-2 rounded-md text-md sm:text-sm mb-6">
                  <p>Nom : {userInfo.name}</p>
                  <p>Email : {userInfo.email}</p>
                  <p>Telephone : {userInfo.phone}</p>
                  <p>Sex : {userInfo.gender}</p>
                  <p>Age : {userInfo.age} ans</p>
                  <hr className="my-2" />
                  <p>Doctor : {selectedFile.doctorData.name} </p>
                  <p>Email : {selectedFile.doctorData.email} </p>
                  <p>Telephone : {selectedFile.doctorData.phone} </p>
                  <p>Spécialité : {selectedFile.doctorData.speciality} </p>
                  <p>Wilaya : {selectedFile.doctorData.wilaya} </p>
                </div>
                <div className="flex ">
                  <div className="flex flex-col w-full sm:w-[50%] pr-1 gap-1 mb-3 text-sm">
                    <div className="flex justify-between px-1">
                      <label htmlFor="height">Taille (cm)</label>
                      <label htmlFor="height"> الطول</label>
                    </div>
                    <input
                      className="form-input px-3 py-2"
                      type="number"
                      name="height"
                      placeholder={
                        selectedFile.fileData?.height
                          ? `${selectedFile.fileData?.height} cm`
                          : "taille en cm"
                      }
                      value={formData.height || selectedFile.fileData?.height}
                      onChange={handleChange}
                      disabled={!isEditing}
                      required
                    />
                  </div>
                  <div className="flex flex-col w-full sm:w-[50%] pl-1 gap-1 mb-3 text-sm">
                    <div className="flex justify-between px-1">
                      <label htmlFor="weight">Poids (kg)</label>
                      <label htmlFor="weight"> الوزن</label>
                    </div>
                    <input
                      className="form-input px-3 py-2"
                      type="number"
                      name="weight"
                      placeholder={
                        selectedFile.fileData?.weight
                          ? `${selectedFile.fileData?.weight} kg`
                          : "poids en kg"
                      }
                      value={formData.weight || selectedFile.fileData?.weight}
                      onChange={handleChange}
                      disabled={!isEditing}
                      required
                    />
                  </div>
                </div>
                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label htmlFor="bloodType">Groupe sanguin </label>
                    <label htmlFor="bloodType"> فئه الدم</label>
                  </div>
                  <select
                    name="bloodType"
                    value={
                      formData.bloodType || selectedFile?.fileData?.bloodType
                    }
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.bloodType ? (
                      <option value={selectedFile.fileData?.bloodType}>
                        {selectedFile.fileData.bloodType}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                  </select>
                </div>

                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label htmlFor="smoking">Fumeur </label>
                    <label htmlFor="smoking"> التدخين</label>
                  </div>
                  <select
                    name="smoking"
                    value={formData.smoking || selectedFile?.fileData?.smoking}
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.smoking ? (
                      <option value={selectedFile.fileData?.smoking}>
                        {selectedFile.fileData.smoking}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="Souvent - غالبا">Souvent - غالبا</option>
                    <option value="Rarement - نادرا">Rarement - نادرا</option>
                    <option value="Jamais - ابدا">Jamais - ابدا</option>
                  </select>
                </div>
                {/* Chronic Disease */}
                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label>Maladie chronique </label>
                    <label className="text-right"> مرض مزمن</label>
                  </div>
                  <select
                    name="chronicDisease"
                    value={
                      formData.chronicDisease ||
                      selectedFile?.fileData?.chronicDisease
                    }
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.chronicDisease ? (
                      <option value={selectedFile.fileData?.chronicDisease}>
                        {selectedFile.fileData?.chronicDisease}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="Oui - نعم">Oui - نعم</option>
                    <option value="Non - لا">Non - لا</option>
                  </select>
                  {(formData.chronicDisease === "Oui - نعم" ||
                    selectedFile.fileData?.chronicDisease === "Oui - نعم") && (
                    <input
                      type="text"
                      name="chronicDiseaseName"
                      placeholder="Nom de la maladie - اسم المرض"
                      value={
                        formData.chronicDiseaseName ||
                        selectedFile.fileData?.chronicDiseaseName
                      }
                      onChange={handleChange}
                      disabled={!isEditing}
                      required
                      className="form-input px-3 py-2"
                    />
                  )}
                </div>

                {/* Family Disease */}
                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label>
                      Est-ce qu'un membre de votre famille souffre d'une maladie
                      ?
                    </label>
                    <label className="text-right">
                      هل يعاني أي شخص في عائلتك من أي أمراض؟{" "}
                    </label>
                  </div>
                  <select
                    name="familyDisease"
                    value={
                      formData.familyDisease ||
                      selectedFile?.fileData?.familyDisease
                    }
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.familyDisease ? (
                      <option value={selectedFile.fileData?.familyDisease}>
                        {selectedFile.fileData?.familyDisease}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="Oui - نعم">Oui - نعم</option>
                    <option value="Non - لا">Non - لا</option>
                  </select>
                  {(formData.familyDisease === "Oui - نعم" ||
                    selectedFile.fileData?.familyDisease === "Oui - نعم") && (
                    <>
                      <input
                        type="text"
                        name="familyDiseaseName"
                        placeholder="Nom de la maladie - اسم المرض"
                        value={
                          formData.familyDiseaseName ||
                          selectedFile.fileData?.familyDiseaseName
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-2"
                      />
                      <select
                        name="relationship"
                        value={
                          formData.relationship ||
                          selectedFile?.fileData?.relationship
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-1"
                      >
                        {selectedFile?.fileData?.relationship ? (
                          <option value={selectedFile.fileData?.relationship}>
                            {selectedFile.fileData?.relationship}
                          </option>
                        ) : (
                          <option value="">
                            Choisir relation - اختر العلاقة
                          </option>
                        )}
                        <option value="Père - الأب">Père - الأب</option>
                        <option value="Mère - الأم">Mère - الأم</option>
                        <option value="Frère - الأخ">Frère - الأخ</option>
                        <option value="Soeur - الأخت">Soeur - الأخت</option>
                        <option value="Mari - زوج">Mari - زوج</option>
                        <option value="Femme - زوجة">Femme - زوجة</option>
                        <option value="Fils - ابن">Fils - ابن</option>
                        <option value="Fille - ابنة">Fille - ابنة</option>
                        <option value="L'oncle - العم">L'oncle - العم</option>
                        <option value="Mes proches - الأقارب">
                          Mes proches - الأقارب
                        </option>
                      </select>
                    </>
                  )}
                </div>
              </div>
              <div className="flex flex-col w-full px-4 sm:px-0">
                {/* Medication */}
                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label>Médicaments </label>
                    <label className="text-right"> هل تتناول الأدوية؟</label>
                  </div>
                  <select
                    name="medication"
                    value={
                      formData.medication || selectedFile?.fileData?.medication
                    }
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.medication ? (
                      <option value={selectedFile.fileData?.medication}>
                        {selectedFile.fileData?.medication}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="Oui - نعم">Oui - نعم</option>
                    <option value="Non - لا">Non - لا</option>
                  </select>
                  {(formData.medication === "Oui - نعم" ||
                    selectedFile.fileData?.medication === "Oui - نعم") && (
                    <>
                      <input
                        type="text"
                        name="medicationNames"
                        placeholder="Noms des médicaments - أسماء الأدوية"
                        value={
                          formData.medicationNames ||
                          selectedFile?.fileData?.medicationNames
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-2"
                      />
                      <textarea
                        type="text"
                        name="medicationInfo"
                        placeholder="Informations supplémentaires - معلومات إضافية"
                        value={
                          formData.medicationInfo ||
                          selectedFile?.fileData?.medicationInfo
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="px-3 py-2 overflow-y-auto h-[90px]"
                      />
                    </>
                  )}
                </div>
                {/* Alergies */}
                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label>Avez-vous des allergies ? </label>
                    <label className="text-right">هل لديك أي حساسية؟</label>
                  </div>
                  <select
                    name="allergies"
                    value={
                      formData.allergies || selectedFile?.fileData?.allergies
                    }
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.allergies ? (
                      <option value={selectedFile.fileData?.allergies}>
                        {selectedFile.fileData?.allergies}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="Oui - نعم">Oui - نعم</option>
                    <option value="Non - لا">Non - لا</option>
                  </select>
                  {(formData.allergies === "Oui - نعم" ||
                    selectedFile.fileData?.allergies === "Oui - نعم") && (
                    <>
                      <input
                        type="text"
                        name="allergiesNames"
                        placeholder="Noms des allergies - أسماء الحساسية"
                        value={
                          formData.allergiesNames ||
                          selectedFile?.fileData?.allergiesNames
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-2"
                      />
                      <textarea
                        type="text"
                        name="allergiesInfo"
                        placeholder="Informations supplémentaires - معلومات إضافية"
                        value={
                          formData.allergiesInfo ||
                          selectedFile?.fileData?.allergiesInfo
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="px-3 py-2 overflow-y-auto h-[90px]"
                      />
                    </>
                  )}
                </div>
                {/* Med Tests */}
                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label>Avez-vous subi des examens médicaux ? </label>
                    <label className="text-right">
                      {" "}
                      هل أجريت أية فحوصات طبية؟
                    </label>
                  </div>
                  <select
                    name="tests"
                    value={formData.tests || selectedFile?.fileData?.tests}
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.tests ? (
                      <option value={selectedFile.fileData?.tests}>
                        {selectedFile.fileData?.tests}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="Oui - نعم">Oui - نعم</option>
                    <option value="Non - لا">Non - لا</option>
                  </select>
                  {(formData.tests === "Oui - نعم" ||
                    selectedFile.fileData?.tests === "Oui - نعم") && (
                    <>
                      <input
                        type="text"
                        name="testsNames"
                        placeholder="Noms des tests -  أسماء الاختبارات , ex: Test A, Test B ..."
                        value={
                          formData.testsNames ||
                          selectedFile.fileData?.testsNames
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-2"
                      />
                      <input
                        type="text"
                        name="testsResults"
                        placeholder="Résultats des tests -   نتائج الاختبارات "
                        value={
                          formData.testsResults ||
                          selectedFile.fileData?.testsResults
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-2"
                      />
                      <textarea
                        type="text"
                        name="testsInfo"
                        placeholder="Informations supplémentaires - معلومات إضافية"
                        value={
                          formData.testsInfo || selectedFile.fileData?.testsInfo
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        className="px-3 py-2 overflow-y-auto h-[90px]"
                      />
                    </>
                  )}
                </div>
                {/* Operations */}
                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label>Opérations chirurgicales ? </label>
                    <label className="text-right">
                      هل أجريت أي عمليات جراحية؟
                    </label>
                  </div>
                  <select
                    name="operations"
                    value={
                      formData.operations || selectedFile?.fileData?.operations
                    }
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.operations ? (
                      <option value={selectedFile.fileData?.operations}>
                        {selectedFile.fileData?.operations}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="Oui - نعم">Oui - نعم</option>
                    <option value="Non - لا">Non - لا</option>
                  </select>
                  {(formData.operations === "Oui - نعم" ||
                    selectedFile.fileData?.operations === "Oui - نعم") && (
                    <>
                      <input
                        type="text"
                        name="operationsNames"
                        placeholder="Noms des Opérations -  أسماء العمليات"
                        value={
                          formData.operationsNames ||
                          selectedFile.fileData?.operationsNames
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-2"
                      />
                      <textarea
                        type="text"
                        name="operationsInfo"
                        placeholder="Informations supplémentaires - معلومات إضافية"
                        value={
                          formData.operationsInfo ||
                          selectedFile.fileData?.operationsInfo
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className=" px-3 py-2 overflow-y-auto h-[90px]"
                      />
                    </>
                  )}
                </div>
                {/* Insurance */}
                <div className="flex flex-col w-full gap-1 mb-3 text-sm">
                  <div className="flex justify-between px-1">
                    <label>Avez-vous une assurance sociale ? </label>
                    <label className="text-right">
                      {" "}
                      هل لديك تأمين اجتماعي؟
                    </label>
                  </div>
                  <select
                    name="insurance"
                    value={
                      formData.insurance || selectedFile?.fileData?.insurance
                    }
                    onChange={handleChange}
                    disabled={!isEditing}
                    required
                    className="form-input px-3 py-1"
                  >
                    {selectedFile?.fileData?.insurance ? (
                      <option value={selectedFile.fileData?.insurance}>
                        {selectedFile.fileData?.insurance}
                      </option>
                    ) : (
                      <option value="">sélectionner</option>
                    )}
                    <option value="Oui - نعم">Oui - نعم</option>
                    <option value="Non - لا">Non - لا</option>
                  </select>
                  {(formData.insurance === "Oui - نعم" ||
                    selectedFile.fileData?.insurance === "Oui - نعم") && (
                    <>
                      <input
                        type="text"
                        name="insuranceType"
                        placeholder={
                          selectedFile.fileData?.insuranceType
                            ? `${selectedFile.fileData?.insuranceType}`
                            : "Type d'assurance -   نوع التأمين"
                        }
                        value={
                          formData.insuranceType ||
                          selectedFile.fileData?.insuranceType
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-2"
                      />
                      <input
                        type="text"
                        name="insuranceNumber"
                        placeholder={
                          selectedFile.fileData?.insuranceNumber
                            ? `${selectedFile.fileData?.insuranceNumber}`
                            : "Numéro d'assurance  -  رقم التأمين"
                        }
                        value={
                          formData.insuranceNumber ||
                          selectedFile.fileData?.insuranceNumber
                        }
                        onChange={handleChange}
                        disabled={!isEditing}
                        required
                        className="form-input px-3 py-2"
                      />
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="bg-slate-200 rounded-lg p-2 mt-5 text-center">
              <h2>Documents Existants - المستندات الموجودة </h2>
              <div className="grid grid-cols-3 gap-4">
                {selectedFile.documents &&
                  selectedFile.documents.map((doc, index) => (
                    <div key={index} className="p-2 border rounded">
                      <img src={doc.path} alt={doc.name} />
                    </div>
                  ))}
              </div>
              <div className="flex flex-col justify-center items-center">
                <h2>تحميل مستند جديد</h2>
                <input
                  type="file"
                  multiple
                  onChange={handleUpload}
                  className="form-input px-3 py-2"
                />
              </div>

              {documents.length > 0 && (
                <div className="grid grid-cols-3 gap-4 mt-2">
                  {documents.map((doc, index) => (
                    <div key={index} className="p-2 border rounded relative">
                      <button
                        onClick={() => handleRemove(index)}
                        className="absolute top-0 right-0 text-red-600"
                      >
                        ✖
                      </button>
                      {doc.file.type.includes("image") ? (
                        <img
                          src={doc.preview}
                          alt={doc.file.name}
                          className="w-full h-20 object-cover"
                        />
                      ) : (
                        <p>{doc.file.name}</p>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="flex justify-between mt-6">
              <button
                onClick={closeDetails}
                className="second-btn sm:text-sm mx-2"
              >
                Fermer - إغلاق
              </button>
              {isEditing ? (
                <button
                  onClick={handleSave}
                  className="main-btn2 sm:text-sm mx-2"
                >
                  Sauvegarder - حفظ
                </button>
              ) : (
                <button
                  onClick={handleEditToggle}
                  className="main-btn2 sm:text-sm mx-2"
                >
                  Modifier - تعديل
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MedicalFiles;
